import React from 'react'
import PropTypes from 'prop-types'
import styles from './Field.module.scss'

let seq = 0

export const useFieldId = provided => {
  const ref = React.useRef(null)
  if (ref.current === null) ref.current = `rox-field-${++seq}`
  return provided || ref.current
}

export const messageIdFor = fieldId => `${fieldId}-message`

const cx = (...p) => p.filter(Boolean).join(' ')

const Field = ({ id, label, required, hint, error, children, className }) => (
  <div className={cx(styles.field, className)}>
    {label && (
      <label className={styles.label} htmlFor={id}>
        {label}
        {required && (
          <span className={styles.required} aria-hidden="true">
            {' *'}
          </span>
        )}
      </label>
    )}

    {children}

    {}
    {error ? (
      <p className={styles.error} id={id && messageIdFor(id)} role="alert">
        {error}
      </p>
    ) : hint ? (
      <p className={styles.hint} id={id && messageIdFor(id)}>
        {hint}
      </p>
    ) : null}
  </div>
)

Field.propTypes = {
  id: PropTypes.string,
  label: PropTypes.node,
  required: PropTypes.bool,

  hint: PropTypes.node,
  error: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
}

export default Field
